const WEEKDAYS = ["L", "M", "M", "G", "V", "S", "D"];

const DOT = {
  green: "bg-emerald-500",
  red: "bg-red-500",
  amber: "bg-amber-500",
  empty: "bg-zinc-700",
  closed: "bg-zinc-800 ring-1 ring-zinc-600",
  future: "bg-transparent border border-zinc-800",
};

export const HaccpCalendar = ({ cal, onDayClick }) => {
  if (!cal?.days?.length) return null;
  const offset = cal.days[0].weekday;

  return (
    <div data-testid="haccp-calendar">
      <div className="grid grid-cols-7 gap-1 mb-1">
        {WEEKDAYS.map((w, i) => (
          <div key={i} className="text-[10px] text-zinc-500 text-center font-medium">{w}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {Array.from({ length: offset }).map((_, i) => <div key={`pad-${i}`} />)}
        {cal.days.map((d) => (
          <button
            key={d.date}
            type="button"
            data-testid={`haccp-day-${d.date}`}
            onClick={() => onDayClick?.(d)}
            className="flex flex-col items-center gap-1 py-1.5 rounded-lg hover:bg-white/5 transition-colors active:scale-95"
            title={`${d.date}${d.status === "closed" ? " · chiuso (domenica/festivo)" : ` · temp ${d.temps}/${d.temps_expected}${d.temps_bad ? ` · ${d.temps_bad} fuori range` : ""}${d.nc ? ` · ${d.nc} NC` : ""}`}`}
          >
            <span className={`text-[11px] ${d.status === "future" || d.status === "closed" ? "text-zinc-600" : "text-zinc-300"}`}>{d.day}</span>
            <span className={`w-2 h-2 rounded-full ${DOT[d.status] || DOT.empty}`} />
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-3 mt-3 text-[10px] text-zinc-500">
        <span className="flex items-center gap-1"><i className="w-2 h-2 rounded-full bg-emerald-500 inline-block" /> completo</span>
        <span className="flex items-center gap-1"><i className="w-2 h-2 rounded-full bg-amber-500 inline-block" /> parziale</span>
        <span className="flex items-center gap-1"><i className="w-2 h-2 rounded-full bg-red-500 inline-block" /> fuori range / NC</span>
        <span className="flex items-center gap-1"><i className="w-2 h-2 rounded-full bg-zinc-700 inline-block" /> nessun dato</span>
        <span className="flex items-center gap-1"><i className="w-2 h-2 rounded-full bg-zinc-800 ring-1 ring-zinc-600 inline-block" /> chiuso</span>
      </div>
    </div>
  );
};
